<base-index-page
    [config]="baseIndexPageConfig"
    [service]="qualityManagementService"
    [idKey]="'riskId'"
    [subSectionSettings]="'deleteRisk'"
></base-index-page>
